module.exports = __webpack_public_path__ + "img/pp-green.514140b9.png";